const STAGING_ENV = "api-egtrade-staging.com";
const PROD_ENV = "api-egtrade.com";
// TODO: Get env details from JWT token instead of window location
const hostname = window && window.location && window.location.hostname;

let REWARDS_BASE_URL: string;
const rewardUrls = {
  [PROD_ENV]: "https://api-egtrade.com/egtrade-api-rewards/api/v2",
  [STAGING_ENV]: "https://api-egtrade-staging.com/egtrade-api-rewards/api/v2",
};
// Default to staging if hostname doesn't match
REWARDS_BASE_URL = rewardUrls[hostname] || "https://api-egtrade-staging.com/egtrade-api-rewards/api/v2";

export { REWARDS_BASE_URL };
